module.exports = __webpack_public_path__ + "img/p-2-5.0dfb8082.jpg";